<template>
  <UModal
    v-model:open="open"
    :title="props.title"
    :dismissible="false"
    :description="props.description"
    :close="false"
    :ui="{
      footer: 'justify-end gap-3',
      content: 'z-[9999]',
      overlay: 'z-[9999]',
    }"
  >
    <template
      v-if="props.content !== undefined"
      #description
    >
      <component :is="props.content"></component>
    </template>
    <template #footer>
      <div
        class="flex flex-col sm:flex-row w-full sm:w-auto justify-between gap-3"
      >
        <UButton
          v-for="(action, id) in props.actions"
          v-bind="action"
          :key="id"
        >
        </UButton>
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
import type { ButtonProps } from "@nuxt/ui";
import type { VNode } from "vue";

interface Props {
  title?: string;
  description?: string;
  content?: VNode;
  actions?: ButtonProps[];
}

const props = ref({
  title: undefined,
  description: undefined,
  actions: undefined,
  content: undefined,
});

const open = ref(false);
const show = (data: Props) => {
  props.value = {
    ...props.value,
    ...data,
  };

  open.value = true;
};

const hide = () => {
  open.value = false;
};

defineExpose({ show, hide });
</script>

<style scoped></style>
